import { render } from "./form_pension.vue?vue&type=template&id=0e1fcc74&scoped=true"
import script from "./form_pension.vue?vue&type=script&lang=js"
export * from "./form_pension.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=0e1fcc74&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e1fcc74"]])

export default __exports__